import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UnifiedProfilePersonal extends BaseModel {
  static override constructorName = 'UnifiedProfilePersonalModel'

  'first_name': string | null = null
  'last_name': string | null = null
  'middle_name': string | null = null
  'birth_date': string | null = null
  phone: string | null = null
  email: string | null = null
  sex: string | null = null
  snils: string | null = null
  inn: string | null = null
  'citizenship_id': number | null = null
  citizenship: string = ''
  city: string | null = null
  'region_id': number | null = null
  region: string = ''
  photo: string | null = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfilePersonal)
